<template>
  <div class="jlxk-home">
    <div class="jlxk-home_item">
      <div class="jlxk-home_item-title">
        数据入库统计
        <Datepicker
          separator="~"
          :default-time="defaultTime"
          :is-show-icon="true"
          @timeChange="timeChange"
        />
      </div>
      <ul class="data-info-box">
        <li
          v-for="(item, index) in dataBox"
          :key="index"
        >
          <i :class="['icon', `jlxk-home-${item.icon}`]" />
          <span class="data-box-data">{{ item.data }}</span>
          <span class="data-box-name">{{ item.name }}</span>
        </li>
      </ul>
      <div class="jlxk-home_item-line" />
    </div>
    <div class="jlxk-home_content">
      <div class="jlxk-home_content-left">
        <div class="jlxk-home_item">
          <div class="jlxk-home_item-title">
            各主题数据入库占比Top3
            <div class="row-title-icon">
              <i
                class="icon jlxk-home-download"
                @mouseenter="isShowTips(0, true, 'saveAsImgFlag')"
                @mouseleave="isShowTips(0, false, 'saveAsImgFlag')"
                @click="download('themeDataRank', '各主题数据入库占比Top3')"
              >
                <span v-show="saveAsImgFlag[0]">保存图片</span>
              </i>
            </div>
          </div>
          <pie-chart
            ref="themeDataRank"
            :data-list="themeStorageData"
            echarts-id="1"
          />
        </div>
        <div class="jlxk-home_item">
          <div class="jlxk-home_item-title">
            各型数据入库占比Top3
            <div class="row-title-icon">
              <i
                class="icon jlxk-home-download"
                @mouseenter="isShowTips(1, true, 'saveAsImgFlag')"
                @mouseleave="isShowTips(1, false, 'saveAsImgFlag')"
                @click="download('sourceDataRank', '各型数据入库占比Top3')"
              >
                <span v-show="saveAsImgFlag[1]">保存图片</span>
              </i>
            </div>
          </div>
          <pie-chart
            ref="sourceDataRank"
            :data-list="sourcesStorageData"
            echarts-id="2"
          />
        </div>
        <div class="jlxk-home_item">
          <div class="jlxk-home_item-title">
            各类数据入库占比Top3
            <div class="row-title-icon">
              <i
                class="icon jlxk-home-download"
                @mouseenter="isShowTips(2, true, 'saveAsImgFlag')"
                @mouseleave="isShowTips(2, false, 'saveAsImgFlag')"
                @click="download('atriclePieRank', '各类数据入库占比Top3')"
              >
                <span v-show="saveAsImgFlag[2]">保存图片</span>
              </i>
            </div>
          </div>
          <pie-chart
            ref="atriclePieRank"
            :data-list="atricleStorageData"
            echarts-id="3"
          />
        </div>
      </div>
      <div class="jlxk-home_content-right">
        <div class="line">
          <div class="jlxk-home_item">
            <div class="jlxk-home_item-title">
              各类数据入库排行榜
              <div class="row-title-icon">
                <i
                  class="icon jlxk-home-save"
                  @mouseenter="isShowTips(0, true)"
                  @mouseleave="isShowTips(0, false)"
                  @click="exportToExcel('articleRank', '各类数据入库排行榜')"
                >
                  <span v-show="exportFlag[0]">数据导出</span></i>
                <i
                  class="icon jlxk-home-download"
                  @mouseenter="isShowTips(3, true, 'saveAsImgFlag')"
                  @mouseleave="isShowTips(3, false, 'saveAsImgFlag')"
                  @click="download('articleRank', '各类数据入库排行榜')"
                >
                  <span v-show="saveAsImgFlag[3]">保存图片</span>
                </i>
              </div>
            </div>
            <BarChart
              ref="articleRank"
              echarts-id="1"
              :data-list="articleBarData"
            />
          </div>
          <div class="jlxk-home_item">
            <div class="jlxk-home_item-title">
              各型数据入库排行榜
              <div class="row-title-icon">
                <i
                  class="icon jlxk-home-save"
                  @mouseenter="isShowTips(1, true)"
                  @mouseleave="isShowTips(1, false)"
                  @click="exportToExcel('userDataRank', '各型数据入库排行榜')"
                >
                  <span v-show="exportFlag[1]">数据导出</span></i>
                <i
                  class="icon jlxk-home-download"
                  @mouseenter="isShowTips(4, true, 'saveAsImgFlag')"
                  @mouseleave="isShowTips(4, false, 'saveAsImgFlag')"
                  @click="download('userDataRank', '各型数据入库排行榜')"
                >
                  <span v-show="saveAsImgFlag[4]">保存图片</span>
                </i>
              </div>
            </div>
            <BarChart
              ref="userDataRank"
              echarts-id="2"
              :data-list="userDataStrogeData"
            />
          </div>
        </div>
        <div class="jlxk-home_item">
          <div class="jlxk-home_item-title">
            数据上传个人排行榜
            <div class="row-title-icon">
              <i
                class="icon jlxk-home-save"
                @mouseenter="isShowTips(2, true)"
                @mouseleave="isShowTips(2, false)"
                @click="exportToExcel('behavierDataRank', '数据上传个人排行榜')"
              >
                <span v-show="exportFlag[2]">数据导出</span></i>
              <i
                class="icon jlxk-home-download"
                @mouseenter="isShowTips(5, true, 'saveAsImgFlag')"
                @mouseleave="isShowTips(5, false, 'saveAsImgFlag')"
                @click="download('behavierDataRank', '数据上传个人排行榜')"
              >
                <span v-show="saveAsImgFlag[5]">保存图片</span>
              </i>
            </div>
          </div>
          <BarChart
            ref="behavierDataRank"
            echarts-id="3"
            :data-list="behavierData"
          />
        </div>
      </div>
    </div>
    <!-- 数据上传机构排行榜 -->
    <div class="jlxk-home_item jlxk-home_item-department">
      <div class="jlxk-home_item-title">
        数据上传机构排行榜
        <div class="row-title-icon">
          <i
            class="icon jlxk-home-save"
            @mouseenter="isShowTips(3, true)"
            @mouseleave="isShowTips(3, false)"
            @click="exportToExcel('departmentData', '数据上传机构排行榜')"
          >
            <span v-show="exportFlag[3]">数据导出</span></i>
          <i
            class="icon jlxk-home-download"
            @mouseenter="isShowTips(6, true, 'saveAsImgFlag')"
            @mouseleave="isShowTips(6, false, 'saveAsImgFlag')"
            @click="download('departmentData', '数据上传机构排行榜')"
          >
            <span v-show="saveAsImgFlag[6]">保存图片</span>
          </i>
        </div>
      </div>
      <BarChart
        ref="departmentData"
        echarts-id="4"
        :data-list="departmentBarData"
      />
    </div>
  </div>
</template>

<script>
import {
  formatNumWidthComma,
  getTimeParamCy,
  downloadImg,
  exportTimeFormat
} from '@common/util.js'
import Datepicker from '@components/common/DatePicker'
import PieChart from './components/pieChart.vue'
import BarChart from './components/barChart'
import APIS from '@apis/jlxk'
const barOptions = {
  xAxisData: {
    type: 'value',
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      show: false
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#EAEAEA',
        width: 1,
        type: 'dashed'
      }
    }
  }
}
export default {
  components: {
    PieChart,
    BarChart,
    Datepicker
  },
  data() {
    return {
      typeObj: {
        1: '图文',
        2: '图集',
        6: '音频',
        5: '视频',
        3: '书籍文件',
        4: '影视作品'
      },
      defaultTime: Object.values(getTimeParamCy('7d')),
      datetimerange: [],
      dataBox: [
        { icon: 'total', data: 0, name: '入库总量', code: 'all' },
        { icon: 'essay', data: 0, name: '图文数据', code: 1 },
        { icon: 'photo', data: 0, name: '图集数据', code: 2 },
        { icon: 'music', data: 0, name: '音频数据', code: 6 },
        { icon: 'video', data: 0, name: '视频数据', code: 5 },
        { icon: 'book', data: 0, name: '书籍文件', code: 3 },
        { icon: 'movie', data: 0, name: '影视作品', code: 4 }
      ],
      themeStorageData: [],
      sourcesStorageData: [],
      atricleStorageData: [],
      articleBarData: Object.assign({}, barOptions, {
        yAxisData: {
          type: 'category',
          inverse: true,
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#dfdfdf'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#454647',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'bar',
            itemStyle: {
              barBorderRadius: [0, 5, 5, 0],
              color: '#00CBB4'
            },
            label: {
              show: true,
              color: '#00CBB4',
              fontSize: 10,
              position: 'right'
            },
            labelLine: {
              show: false
            },
            barWidth: 8,
            data: []
          }
        ]
      }),
      userDataStrogeData: Object.assign({}, barOptions, {
        yAxisData: {
          type: 'category',
          inverse: true,
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#dfdfdf'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#454647',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'bar',
            itemStyle: {
              barBorderRadius: [0, 5, 5, 0],
              color: '#FF6160'
            },
            label: {
              show: true,
              color: '#FF6160',
              fontSize: 10,
              position: 'right'
            },
            labelLine: {
              show: false
            },
            barWidth: 8,
            data: []
          }
        ]
      }),
      behavierData: {
        xAxisData: {
          type: 'category',
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#EAEAEA',
              width: 1,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#454647',
            fontSize: 12
          }
        },
        yAxisData: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EAEAEA',
              width: 1,
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            itemStyle: {
              barBorderRadius: 0,
              color: '#3273FF'
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            barWidth: 18,
            data: []
          }
        ]
      },
      departmentBarData: {
        grid: {
          left: '10',
          top: '20',
          right: '40',
          bottom: '20',
          containLabel: true
        },
        xAxisData: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#666'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EAEAEA',
              width: 1,
              type: 'dashed'
            }
          }
        },
        yAxisData: {
          type: 'category',
          inverse: true,
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#454647',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'bar',
            itemStyle: {
              barBorderRadius: 0,
              color: '#3273FF'
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            barWidth: 8,
            data: []
          }
        ]
      },
      exportField: require('./data/export.json'),
      articleRankExportData: [],
      userDataRankExportData: [],
      behavierDataRankExportData: [],
      departmentDataExportData: [],
      exportFlag: [false, false, false, false], // 导出图标提示
      saveAsImgFlag: [false, false, false, false, false, false, false] // 保存图片提示
    }
  },
  computed: {
    typeName() {
      return Object.values(this.typeObj)
    },
    exportIntro() {
      return function(modelName) {
        return [
          [`${modelName}`],
          [`起止时间：${this.datetimerange[0]} 至 ${this.datetimerange[1]}`],
          []
        ]
      }
    }
  },
  created() {
    this.datetimerange = [...this.defaultTime]
    // this.userDataStrogeData.yAxisData.data = [...this.typeName];  会导致各型数据入库排行榜y轴固定
    this.initData()
  },
  mounted() {
    this.$refs.articleRank.option.tooltip.axisPointer.shadowStyle = {
      color: 'rgba(0, 203, 180, 0.1)'
    }
    this.$refs.userDataRank.option.tooltip.axisPointer.shadowStyle = {
      color: 'rgba(255, 97, 96, 0.1)'
    }
  },
  methods: {
    initData() {
      this.getStatisticArticletype()
      this.getStatisticDataCategory()
      this.getStatisticPeopleRank()
      this.getStatisticTopictypeTop3()
      this.getStatisticDepartmentRank()
    },
    getParams(isShowDatatype = false) {
      return {
        beginCreated: this.datetimerange[0],
        endCreated: this.datetimerange[1],
        dataType: isShowDatatype ? 'special' : undefined
      }
    },
    // 类型统计
    async getStatisticArticletype() {
      let result = []
      let nameresult = []
      let pieResult = []
      this.userDataRankExportData = []
      let { status, data } = await APIS.postStatisticArticletype({
        data: this.getParams(),
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0 && data && JSON.stringify(data) !== '{}') {
        // 入库统计
        Object.keys(data).forEach(item => {
          let index = this.dataBox.findIndex(i => {
            return String(i.code) === String(item)
          })
          this.dataBox[index].data = formatNumWidthComma(data[item])
        })
        // 用户数据入库量
        Object.keys(this.typeObj).forEach(item => {
          pieResult.push([item, data[item]])
        })
        let sortArr = pieResult.sort((a, b) => b[1] - a[1])
        this.userDataRankExportData = sortArr.map(item => {
          return {
            name: this.typeObj[item[0]],
            count: item[1]
          }
        })
        result = this.userDataRankExportData.map(item => item.count)
        nameresult = this.userDataRankExportData.map(item => item.name)
        // 各型数据入库占比TOP3
        let arr = sortArr.slice(0, 3)
        let total = arr.reduce((a, b) => {
          return (isNaN(b[1]) ? 0 : b[1]) + a
        }, 0)
        this.sourcesStorageData = arr.map((item, index) => {
          return {
            name: this.typeObj[item[0]],
            value: item[1]
          }
        })
        let count = data.all - total
        this.sourcesStorageData.push({ name: '其他', value: count })
      } else {
        this.sourcesStorageData = []
      }
      this.userDataStrogeData.series[0].data = [...result]
      this.userDataStrogeData.yAxisData.data = [...nameresult]
    },
    // 十四大类数据
    async getStatisticDataCategory() {
      this.articleBarData.yAxisData.data = []
      this.articleBarData.series[0].data = []
      this.atricleStorageData = []
      this.articleRankExportData = []
      let { status, data } = await APIS.postStatisticDataCategory({
        data: Object.assign({}, this.getParams(true), {
          topDataCategoryId: 0,
          isTop3: true
        }),
        headers: { 'Content-Type': 'application/json' }
      })
      if (
        status === 0 &&
        data &&
        JSON.stringify(data) !== '{}' &&
        data.data &&
        data.data.length !== 0
      ) {
        let total = data.data.slice(0, 2).reduce((a, b) => {
          return (isNaN(b.count) ? 0 : b.count) + a
        }, 0)
        data.data.forEach((item, index) => {
          // 饼图
          if (index <= 2) {
            this.atricleStorageData.push({
              name: item.name,
              value: item.count
            })
          }
          // 柱状图
          if (index <= 9) {
            this.articleBarData.yAxisData.data.push(item.name)
            this.articleBarData.series[0].data.push(item.count)
          }
          // 导出
          this.articleRankExportData.push({
            name: item.name,
            count: item.count
          })
        })
        let count = data.sum - total
        this.atricleStorageData.push({ name: '其他', value: count })
      }
    },
    // top3主题数据
    async getStatisticTopictypeTop3() {
      let { status, data } = await APIS.postStatisticTopictype({
        data: Object.assign(
          {},
          { groupField: 'topTopic' },
          this.getParams(true)
        ),
        headers: { 'Content-Type': 'application/json' }
      })
      if (
        status === 0 &&
        data &&
        JSON.stringify(data) !== '{}' &&
        data.data &&
        data.data.length !== 0
      ) {
        let total = data.data.reduce((a, b) => {
          return (isNaN(b.count) ? 0 : b.count) + a
        }, 0)
        this.themeStorageData = data.data.map((item, index) => {
          return {
            name: item.name,
            value: item.count
          }
        })
        let count = data.sum - total
        this.themeStorageData.push({ name: '其他', value: count })
      } else {
        this.themeStorageData = []
      }
      console.log(this.themeStorageData)
    },
    // 个人排行
    async getStatisticPeopleRank() {
      this.behavierDataRankExportData = []
      this.behavierData.xAxisData.data = []
      this.behavierData.series[0].data = []
      let { status, data } = await APIS.postStatisticPeopleRank({
        data: Object.assign({}, this.getParams(true), {
          groupField: 'user'
        }),
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0 && data && data.length !== 0) {
        data.forEach(item => {
          this.behavierData.xAxisData.data.push(item.username)
          this.behavierData.series[0].data.push(item.count)
          this.behavierDataRankExportData.push({
            name: item.username,
            count: item.count
          })
        })
      }
    },
    // 部门排行
    async getStatisticDepartmentRank() {
      this.departmentBarData.yAxisData.data = []
      this.departmentBarData.series[0].data = []
      this.departmentDataExportData = []
      let { status, data } = await APIS.postStatisticDepartmentRank({
        data: Object.assign({}, this.getParams(true), {
          groupField: 'department',
          onlyOne: true
        }),
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0 && data && data.length !== 0) {
        data.forEach((item, index) => {
          if (index <= 9) {
            this.departmentBarData.yAxisData.data.push(item.name)
            this.departmentBarData.series[0].data.push(item.count)
          }
          this.departmentDataExportData.push({
            name: item.name,
            count: item.count
          })
        })
      }
    },
    timeChange(value) {
      this.datetimerange = [...value]
      this.initData()
    },
    isShowTips(index, flag, obj = 'exportFlag') {
      this.$set(this[obj], index, flag)
    },
    // 图片下载
    download(obj, name) {
      let url = this.$refs[obj].myChart.getDataURL({
        type: 'png',
        backgroundColor: '#ffffff'
      })
      downloadImg(url, name)
    },
    // 图表数据导出
    exportToExcel(value, name) {
      const th = this.exportField[value].th
      let fileName = `${name}-导出数据-${exportTimeFormat().substring(
        0,
        8
      )}-${exportTimeFormat().substring(8, 12)}`
      const data = this.handleExportData(value)
      this.$jsonToExcel(th, data, fileName, this.exportIntro(name))
    },
    handleExportData(value) {
      let tpropty = this.exportField[value].tpropty
      return this[`${value}ExportData`].map(v => tpropty.map(k => v[k]))
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-home {
  padding-bottom: 20px;
  &_item {
    @extend .comBackground;
    margin-top: 20px;
    padding: 9px 20px 15px;
    &-title {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 0 0 12px;
      font-size: 14px;
      color: #454647;
      &::before {
        position: absolute;
        left: 0px;
        width: 4px;
        height: 4px;
        content: "";
        background: #3273ff;
      }
      /deep/ .cy-date-time-picker {
        margin-left: 17px;
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        overflow: hidden;
        > .icon {
          right: 8px;
        }
        .el-date-editor {
          padding-left: 8px;
          margin-right: 30px;
        }
      }
      .row-title-icon {
        position: absolute;
        right: 0;
        i {
          cursor: pointer;
          position: relative;
          & > span {
            position: absolute;
            width: 66px;
            font-size: 13px;
            color: #4497ec;
            top: 18px;
            font-style: initial;
            left: -18px;
            z-index: 10;
          }
          &:last-child {
            margin-left: 10px;
          }
        }
      }
    }
    .date-picker {
      width: 200px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #e7e7e7;
      border-radius: 5px;
      position: absolute;
      top: 13px;
      left: 138px;
    }
    .data-info-box {
      display: flex;
      justify-content: space-around;
      margin-top: 13px;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-basis: calc(100% / 7);
        font-size: 12px;
        line-height: 16px;
        .data-box-name {
          color: #666;
        }
        &:first-child {
          font-size: 13px;
          font-family: Lantinghei SC;
          font-weight: 600;
          color: #000000;
          .data-box-name {
            font-size: 14px;
            font-family: FZZhengHeiS-DB-GB;
            font-weight: 800;
            font-style: italic;
            color: #454647;
          }
        }
      }
    }
    .jlxk-home_item-line {
      position: absolute;
      top: 65px;
      left: 189px;
      height: 67px;
      width: 1px;
      background-color: #bfbfbf;
    }
    &-department {
      height: 350px;
      padding-top: 15px;
    }
  }
  &_content {
    display: flex;
    justify-content: space-between;
    .jlxk-home_item {
      padding-top: 15px;
    }
    &-left {
      width: 260px;
      margin-right: 20px;
      flex-shrink: 0;
      .jlxk-home_item {
        height: 277px;
      }
    }
    &-right {
      width: 940px;
      flex: 1;
      .jlxk-home_item {
        height: 425px;
      }
      .line {
        display: flex;
        justify-content: space-between;
        .jlxk-home_item {
          width: calc(50% - 10px);
        }
      }
    }
  }
}
</style>
